/**
 * 스튜디오 📍 주소 입력(챗봇 Enter Address → appliedAddress) 결과를 문서용 한 줄 주소로.
 *   SG 로컬 입력은 line(블록·거리·#층-호·건물) 에 우편번호가 없고 postcode·country('Singapore') 가 따로 온다.
 *   예전엔 line 만 써서 "SINGAPORE 416175" 가 통째로 빠졌다 → SG 로컬이면 "…, SINGAPORE 416175" 까지 붙인다.
 *   해외 입력(line 만 옴)·line 이 비어 있는 경우는 기존 조합 그대로.
 */
export interface SgAppliedAddress {
  line?: string; line1?: string; line2?: string; line3?: string;
  town?: string; state?: string; postcode?: string; country?: string;
}

const st = (v: unknown) => String(v ?? '').trim();

export function sgAppliedAddressLine(a: SgAppliedAddress | null | undefined): string {
  if (!a) return '';
  const line = st(a.line);
  const pc = st(a.postcode);
  if (line) {
    const isSg = /^(singapore|sg)$/i.test(st(a.country));
    // 이미 우편번호가 들어 있으면(직접 입력 등) 중복 방지
    if (isSg && pc && !line.includes(pc)) return `${line}, SINGAPORE ${pc}`;
    return line;
  }
  return [a.line1, a.line2, a.line3, [a.postcode, a.town].filter(Boolean).join(' '), a.state, a.country]
    .map(st).filter(Boolean).join(', ');
}
